import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Undo2Outline } from '@lyearn/icons';
import { AlertDialog } from '@lyearn/molecules';
import { useSnackbar } from '@lyearn/ui';
import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import { useDiscardUnpublishedChangesMutation } from '@/modules/corporate/modules/admin/graphql/mutations/generated/discardUnpublishedChanges';

const RevertChangesDialog: React.FC<{
  contentId: string;
  onClose: () => void;
  onSuccess?: () => void;
}> = ({ contentId, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const { showSnackbar } = useSnackbar();
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();
  const [{ fetching }, discardChanges] = useDiscardUnpublishedChangesMutation();

  const onRevert = () =>
    discardChanges({ discardUnpublishedChangesInput: { contentId } })
      .catch(() => showDefaultErrorSnackbar())
      .then(() => {
        showSnackbar({
          startIcon: <Undo2Outline fillColorToken="icon-white" />,
          message: t('Admin:success.ChangesRevertedSuccessfully'),
        });
        onSuccess?.();
      })
      .finally(() => onClose());

  return (
    <AlertDialog
      header={{
        title: t('Admin:RevertChanges'),
        description: t('Admin:RevertDialogDescription'),
      }}
      primaryAction={{
        label: t('Admin:Revert'),
        appearance: 'danger',
        loading: fetching,
        onClick: onRevert,
      }}
      onClose={onClose}
    />
  );
};

export default RevertChangesDialog;
